import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

const MainImage = (props) => {
  const { image } = props;

  return (
    <LazyLoadImage
      alt="main images"
      src={image}
      className="main-img"
      effect="opacity"
      height="100%"
      width="100%"
    />
  );
};

export default MainImage;
